import { tokens } from './tokens';

export const theme = {
   colors: {
      bg: {
         primary: tokens.neutral[1],
         secondary: tokens.neutral[2],
         tertiary: tokens.neutral[3],
      },
      text: {
         primary: tokens.neutral[7],
         secondary: tokens.neutral[6],
         tertiary: tokens.neutral[5],
         disabled: tokens.neutral[4],
         inverse: tokens.neutral[1],
      },
      border: {
         default: tokens.neutral[3],
         subtle: tokens.neutral[2],
         strong: tokens.neutral[4],
         focus: tokens.brand.blue,
      },
      state: {
         success: tokens.semantic.positive,
         warning: tokens.semantic.caution,
         error: tokens.semantic.negative,
         info: tokens.semantic.informative,
         version: tokens.semantic.version,
      },
   },
} as const;
